// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./utils/fonts/adyenconnector-icons.eot?4guc3u", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./utils/fonts/adyenconnector-icons.ttf?4guc3u", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./utils/fonts/adyenconnector-icons.woff?4guc3u", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./utils/fonts/adyenconnector-icons.svg?4guc3u", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Clicker+Script&family=Open+Sans:wght@300;400;600&family=Reenie+Beanie&family=Sacramento&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#adyenconnector-icons" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "adyenconnector-icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
[class^=icon-],
[class*=" icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "adyenconnector-icons" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-eye:before {
  content: "\\e9ce";
}

.icon-eye-blocked:before {
  content: "\\e9d1";
}

.icon-question:before {
  content: "\\ea09";
}

.icon-new-tab:before {
  content: "\\ea7e";
}

.icon-sync:before {
  content: "\\e900";
}

.icon-clock:before {
  content: "\\e901";
}

.icon-cross:before {
  content: "\\e902";
}

.icon-angle-right:before {
  content: "\\e903";
}

.icon-angle-up:before {
  content: "\\e904";
}

.icon-angle-left:before {
  content: "\\e905";
}

.icon-angle-down:before {
  content: "\\e906";
}

.icon-calendar:before {
  content: "\\e907";
}

.icon-download:before {
  content: "\\e908";
}

.icon-trash:before {
  content: "\\e909";
}

.icon-plus:before {
  content: "\\e90a";
}

.icon-search:before {
  content: "\\e90b";
}

.icon-pencil:before {
  content: "\\e90c";
}

.icon-logs:before {
  content: "\\e90d";
}

.icon-users:before {
  content: "\\e90e";
}

.icon-reports:before {
  content: "\\e90f";
}

.icon-marketplaces:before {
  content: "\\e910";
}

.icon-message-typing:before {
  content: "\\e911";
}

/* http://meyerweb.com/eric/tools/css/reset/ 
   v2.0 | 20110126
   License: none (public domain)
*/
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

body {
  line-height: 1;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before, blockquote:after {
  content: "";
  content: none;
}

q:before, q:after {
  content: "";
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

html {
  background: black;
}

body {
  margin: 0;
  font-family: "Open Sans";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #666;
  background: #fff;
  min-height: 100vh;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

a {
  color: #0abf53;
}

::placeholder {
  color: #aaa;
}

iframe {
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/utils/scss/_icons.scss","webpack://./src/index.scss"],"names":[],"mappings":"AAAA;EACE,mCAAA;EACA,4CAAA;EACA,mPAAA;EAKA,mBAAA;EACA,kBAAA;EACA,mBAAA;ACFF;ADKA;;EAEE,+EAAA;EACA,8CAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;ACJF;;ADOA;EACE,gBAAA;ACJF;;ADMA;EACE,gBAAA;ACHF;;ADKA;EACE,gBAAA;ACFF;;ADIA;EACE,gBAAA;ACDF;;ADGA;EACE,gBAAA;ACAF;;ADEA;EACE,gBAAA;ACCF;;ADCA;EACE,gBAAA;ACEF;;ADAA;EACE,gBAAA;ACGF;;ADDA;EACE,gBAAA;ACIF;;ADFA;EACE,gBAAA;ACKF;;ADHA;EACE,gBAAA;ACMF;;ADJA;EACE,gBAAA;ACOF;;ADLA;EACE,gBAAA;ACQF;;ADNA;EACE,gBAAA;ACSF;;ADPA;EACE,gBAAA;ACUF;;ADRA;EACE,gBAAA;ACWF;;ADTA;EACE,gBAAA;ACYF;;ADVA;EACE,gBAAA;ACaF;;ADXA;EACE,gBAAA;ACcF;;ADZA;EACE,gBAAA;ACeF;;ADbA;EACE,gBAAA;ACgBF;;ADdA;EACE,gBAAA;ACiBF;;AA1GA;;;CAAA;AAIA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiFE,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,wBAAA;AA6GF;;AA1GA,gDAAA;AAEA;;;;;;;;;;;EAWE,cAAA;AA4GF;;AAzGA;EACE,cAAA;AA4GF;;AAzGA;;EAEE,gBAAA;AA4GF;;AAzGA;;EAEE,YAAA;AA4GF;;AAxGE;EAEE,WAAA;EACA,aAAA;AA0GJ;;AArGE;EAEE,WAAA;EACA,aAAA;AAuGJ;;AAnGA;EACE,yBAAA;EACA,iBAAA;AAsGF;;AApGA;EACE,iBAAA;AAuGF;;AArGA;EACE,SAAA;EACA,wBAAA;EACA,mCAAA;EACA,kCAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;AAwGF;;AArGA;EACE,+EAAA;AAwGF;;AApGA;EACE,cAAA;AAuGF;;AApGA;EACE,WAAA;AAuGF;;AArGA;EACE,oBAAA;AAwGF","sourcesContent":["@font-face {\n  font-family: \"adyenconnector-icons\";\n  src: url(\"./../fonts/adyenconnector-icons.eot?4guc3u\");\n  src: url(\"./../fonts/adyenconnector-icons.eot?4guc3u#iefix\")\n      format(\"embedded-opentype\"),\n    url(\"./../fonts/adyenconnector-icons.ttf?4guc3u\") format(\"truetype\"),\n    url(\"./../fonts/adyenconnector-icons.woff?4guc3u\") format(\"woff\"),\n    url(\"./../fonts/adyenconnector-icons.svg?4guc3u#adyenconnector-icons\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-\"],\n[class*=\" icon-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: \"adyenconnector-icons\" !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-eye:before {\n  content: \"\\e9ce\";\n}\n.icon-eye-blocked:before {\n  content: \"\\e9d1\";\n}\n.icon-question:before {\n  content: \"\\ea09\";\n}\n.icon-new-tab:before {\n  content: \"\\ea7e\";\n}\n.icon-sync:before {\n  content: \"\\e900\";\n}\n.icon-clock:before {\n  content: \"\\e901\";\n}\n.icon-cross:before {\n  content: \"\\e902\";\n}\n.icon-angle-right:before {\n  content: \"\\e903\";\n}\n.icon-angle-up:before {\n  content: \"\\e904\";\n}\n.icon-angle-left:before {\n  content: \"\\e905\";\n}\n.icon-angle-down:before {\n  content: \"\\e906\";\n}\n.icon-calendar:before {\n  content: \"\\e907\";\n}\n.icon-download:before {\n  content: \"\\e908\";\n}\n.icon-trash:before {\n  content: \"\\e909\";\n}\n.icon-plus:before {\n  content: \"\\e90a\";\n}\n.icon-search:before {\n  content: \"\\e90b\";\n}\n.icon-pencil:before {\n  content: \"\\e90c\";\n}\n.icon-logs:before {\n  content: \"\\e90d\";\n}\n.icon-users:before {\n  content: \"\\e90e\";\n}\n.icon-reports:before {\n  content: \"\\e90f\";\n}\n.icon-marketplaces:before {\n  content: \"\\e910\";\n}\n.icon-message-typing:before {\n  content: \"\\e911\";\n}\n","@import url(\"https://fonts.googleapis.com/css2?family=Clicker+Script&family=Open+Sans:wght@300;400;600&family=Reenie+Beanie&family=Sacramento&display=swap\");\n\n@import \"./utils/scss/icons\";\n\n/* http://meyerweb.com/eric/tools/css/reset/ \n   v2.0 | 20110126\n   License: none (public domain)\n*/\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n}\n\n/* HTML5 display-role reset for older browsers */\n\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block;\n}\n\nbody {\n  line-height: 1;\n}\n\nol,\nul {\n  list-style: none;\n}\n\nblockquote,\nq {\n  quotes: none;\n}\n\nblockquote {\n  &:before,\n  &:after {\n    content: \"\";\n    content: none;\n  }\n}\n\nq {\n  &:before,\n  &:after {\n    content: \"\";\n    content: none;\n  }\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\nhtml {\n  background: black;\n}\nbody {\n  margin: 0;\n  font-family: \"Open Sans\";\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: #666;\n  background: #fff;\n  min-height: 100vh;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\na {\n  color: #0abf53;\n}\n\n::placeholder {\n  color: #aaa;\n}\niframe {\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
